import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import ru from '@angular/common/locales/ru';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BackendPrefixInterceptor, ErrorInterceptor } from 'Core/interceptors';
import { AuthInterceptor } from 'Core/interceptors/auth.interceptor';
import { CurrentUserStateService, UserRequestService } from 'Core/services';
import { ShellModule } from 'Modules/shell/shell.module';
import { NZ_CONFIG, NzConfig } from 'ng-zorro-antd/core/config';
import { NZ_I18N, ru_RU } from 'ng-zorro-antd/i18n';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { ValdemortModule } from 'ngx-valdemort';
import { of, tap } from 'rxjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

registerLocaleData(ru);

export function loadUserData(
  userRequestService: UserRequestService,
  currentUserStateService: CurrentUserStateService,
  ngxPermissionsService: NgxPermissionsService
) {
  return () => {
    const token = localStorage.getItem('accessToken');

    if (!token) {
      return of(null);
    }

    return userRequestService.getPersonalInfo().pipe(
      tap({
        next: res => {
          currentUserStateService.user.set(res);
          ngxPermissionsService.loadPermissions(res.collectionRoles);
        },
      })
    );
  };
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ValdemortModule,
    ShellModule,
    FormsModule,
    BrowserAnimationsModule,
    AngularSvgIconModule.forRoot(),
    NgxPermissionsModule.forRoot(),
  ],
  providers: [
    HttpClient,
    {
      provide: APP_INITIALIZER,
      useFactory: loadUserData,
      deps: [UserRequestService, CurrentUserStateService, NgxPermissionsService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BackendPrefixInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'ru' },
    { provide: NZ_I18N, useValue: ru_RU },
    {
      provide: NZ_CONFIG,
      useValue: {
        notification: { nzDuration: 2000, nzPauseOnHover: true },
      } as NzConfig,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
